import { ROUTER_NAMES } from './routerNamesConfig';

export const COMPANY_GENERATORS = [
	{
		path: 'field-works/:generatorId',
		name: ROUTER_NAMES.FIELD_WORK_ORDERS.GENERATOR,
		component: () => import('@/views/company/generators/field-works/CompanyGeneratorFieldWorksView.vue'),
		children: [
			{
				path: '',
				name: ROUTER_NAMES.FIELD_WORK_ORDERS.GENERATOR_TABS.FIELDS_AND_EXECUTORS,
				component: () => import('@/views/company/generators/field-works/tabs/CompanyGeneratorFieldWorksFieldsAndExecutorsTabView.vue'),
			},
			{
				path: 'params',
				name: ROUTER_NAMES.FIELD_WORK_ORDERS.GENERATOR_TABS.PARAMS,
				component: () => import('@/views/company/generators/field-works/tabs/CompanyGeneratorFieldWorksParamsTabView.vue'),
			},
			{
				path: 'results',
				name: ROUTER_NAMES.FIELD_WORK_ORDERS.GENERATOR_TABS.RESULTS,
				component: () => import('@/views/company/generators/field-works/tabs/CompanyGeneratorFieldWorksResultsTabView.vue'),
			},
		]
	},
]
